var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7280_38481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 24C15.6371 24 18.896 22.3817 21.0967 19.8261H2.90344C5.10408 22.3817 8.36297 24 12.0001 24Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37262 18.6274 0 12 0C5.37262 0 0 5.37262 0 12C0 13.0831 0.144375 14.1323 0.413391 15.1305H23.5867C23.8556 14.1323 24 13.0831 24 12Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.953857 16.6956C1.18519 17.2392 1.45561 17.762 1.76137 18.2609H22.2388C22.5445 17.7619 22.8149 17.2392 23.0463 16.6956H0.953857Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5776 12.7826L8.77185 13.3805H9.40049L8.89195 13.75L9.0862 14.3478L8.5776 13.9783L8.06901 14.3478L8.26331 13.75L7.75476 13.3805H8.3834L8.5776 12.7826Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5776 20.6087L8.77185 21.2066H9.40049L8.89195 21.576L9.0862 22.1739L8.5776 21.8044L8.06901 22.1739L8.26331 21.576L7.75476 21.2066H8.3834L8.5776 20.6087Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93466 17.962L5.12891 18.5598H5.75755L5.249 18.9292L5.44325 19.5272L4.93466 19.1577L4.42607 19.5272L4.62041 18.9292L4.11182 18.5598H4.74041L4.93466 17.962Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32619 13.5652L6.52044 14.1631H7.14903L6.64053 14.5325L6.83478 15.1304L6.32619 14.7609L5.81759 15.1304L6.01194 14.5325L5.5033 14.1631H6.13194L6.32619 13.5652Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11182 16.0273L4.74032 16.0273L4.93461 15.4293L5.12891 16.0273L5.75755 16.0272L5.24896 16.3967L5.44325 16.9946L4.93461 16.6251L4.42607 16.9945L4.62032 16.3967L4.11182 16.0273Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81756 21.2771L6.01181 20.6793L5.50317 20.3099H6.13181L6.32611 19.712L6.52041 20.3098H7.149L6.64041 20.6793L6.83466 21.2772L6.32606 20.9077L5.81756 21.2771Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2192 17.962L12.025 18.5598H11.3964L11.9049 18.9292L11.7106 19.5272L12.2192 19.1577L12.7278 19.5272L12.5335 18.9292L13.0421 18.5598H12.4135L12.2192 17.962Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8277 13.5652L10.6335 14.1631H10.0049L10.5134 14.5325L10.3191 15.1304L10.8277 14.7609L11.3363 15.1304L11.142 14.5325L11.6506 14.1631H11.022L10.8277 13.5652Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0421 16.0273L12.4135 16.0273L12.2193 15.4293L12.025 16.0273L11.3964 16.0272L11.9049 16.3967L11.7106 16.9946L12.2193 16.6251L12.7278 16.9945L12.5335 16.3967L13.0421 16.0273Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3362 21.2771L11.142 20.6793L11.6506 20.3099H11.0219L10.8277 19.712L10.6334 20.3098H10.0048L10.5134 20.6793L10.3191 21.2772L10.8277 20.9077L11.3362 21.2771Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7280_38481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.52b2dd0d36338b483e1a39bf72d24201.svg";
export { ForwardRef as ReactComponent };